import React, { useState } from 'react';
import { Modal } from '../components/base';
import { SellerForm } from '../features/vendedores/SellerForm';
import { fmt } from '../lib/formato';

function SellersView({ sellers, onCreateSeller, onUpdateSeller, onDeleteSeller, isAdmin }) {
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing]   = useState(null);
  return <div className="flex flex-col gap-4">
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-bold text-gray-800">Vendedores</h2>
      {isAdmin && <button onClick={()=>setShowForm(true)} className="bg-blue-500 text-white text-sm px-4 py-2 rounded-full hover:bg-blue-600 font-semibold">+ Novo Vendedor</button>}
    </div>
    {showForm && <Modal title="Novo Vendedor" onClose={()=>setShowForm(false)}>
      <SellerForm onSave={d=>{onCreateSeller(d);setShowForm(false);}} onCancel={()=>setShowForm(false)} />
    </Modal>}
    {editing && <Modal title="Editar Vendedor" onClose={()=>setEditing(null)}>
      <SellerForm seller={editing} onSave={d=>{onUpdateSeller(editing.id,d);setEditing(null);}} onCancel={()=>setEditing(null)} />
    </Modal>}
    {sellers.length===0
      ? <div className="text-center py-16 text-gray-400">Nenhum vendedor cadastrado ainda.</div>
      : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sellers.map(s => (
            <div key={s.id} className="acard rounded-2xl p-4 flex flex-col gap-2 hover:shadow-sm transition-shadow">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-sm">{s.name.slice(0,2).toUpperCase()}</div>
                  <span className="font-semibold text-gray-800">{s.name}</span>
                </div>
                {isAdmin && <div className="flex gap-1">
                  <button aria-label="Editar" onClick={()=>setEditing(s)} className="text-xs text-blue-600 hover:text-blue-800 px-2 py-1 rounded hover:bg-blue-50">✏️</button>
                  <button onClick={()=>{if(confirm('Excluir vendedor?'))onDeleteSeller(s.id);}} className="text-xs text-red-500 hover:text-red-700 px-2 py-1 rounded hover:bg-red-50">🗑</button>
                </div>}
              </div>
              {s.goal_monthly > 0 && <div className="text-xs text-purple-600 font-medium">🎯 Meta: {fmt(s.goal_monthly)}/mês</div>}
              {s.email && <div className="text-xs text-gray-500">✉️ {s.email}</div>}
              {s.phone && <div className="text-xs text-gray-500">📱 {s.phone}</div>}
            </div>
          ))}
        </div>}
  </div>;
}

// ─── PartnersView ─────────────────────────────────────────

export { SellersView };
